module.exports = __webpack_public_path__ + "img/ico_arrow_right_blue.ac22dd70.svg";